export const MATERIAL_ASSESSMENT_STEPS = [
  {
    label: 'Initiate',
    value: 'initiate',
    items: null,
  },
  {
    label: 'Phase 1 - Understanding',
    value: 'phaseUnderstanding',
    items: [
      {
        label: 'Stakeholder ID',
        value: 'stakeholderID',
        type: 'stakeholder_identification',
      },
      {
        label: 'Topic Identification',
        value: 'topicIdentification',
        type: 'topic_identification_1',
      },
      {
        label: 'Topic Refinement',
        value: 'topicRefinement',
        type: 'topic_refinement_1',
      },
    ],
  },
  {
    label: 'Phase 2 - Gather Insight',
    value: 'phaseGatherInsight',
    items: [
      {
        label: 'Templates',
        value: 'survey-creation',
        type: 'insight_creation',
      },
      {
        label: 'Survey',
        value: 'survey',
        type: 'insight_survey',
      },
      {
        label: 'Interview',
        value: 'interview',
        type: 'insight_interviews',
      },
      {
        label: 'Roundtables',
        value: 'roundtables',
        type: 'insight_roundtables',
      },
      {
        label: 'Insights Dashboard',
        value: 'dashboard',
        type: 'insight_dashboard',
      },
    ],
  },
  {
    label: 'Phase 3 - Identification',
    value: 'phaseIdentification',
    items: [
      {
        label: 'Topic Refinement II',
        value: 'topicRefinementII',
        type: 'topic_refinement_2',
      },
      {
        label: 'IRO Identification',
        value: 'iroIdentification',
        type: 'iro_identification',
      },
      {
        label: 'IRO Refinement',
        value: 'iroRefinement',
        type: 'iro_refinement',
      },
      {
        label: 'IRO Scoring',
        value: 'iroScoring',
        type: 'iro_scoring',
      },
    ],
  },
];

export const MATERIAL_ASSESSMENT_STEPS_LABELS = {
  MATERIAL_ASSESSMENT_STEPS: 'Step 1',
};

export const MATERIAL_ASSESSMENT_STAKEHOLDERS_LIST = [
  {
    label: 'Supplier',
    value: 'suppliers',
    type: 'stakeholder_suppliers',
    items: null,
  },
  {
    label: 'Investor',
    value: 'investors',
    type: 'stakeholder_investors',
    items: null,
  },
  {
    label: 'Board',
    value: 'boards',
    type: 'stakeholder_boards',
    items: null,
  },
  {
    label: 'Employee',
    value: 'employees',
    type: 'stakeholder_employees',
    items: null,
  },
  {
    label: 'Customer',
    value: 'customers',
    type: 'stakeholder_customers',
    items: null,
  },
  {
    label: 'Local Community',
    value: 'local_communities',
    type: 'stakeholder_local_communities',
    items: null,
  },
  {
    label: 'Media',
    value: 'media',
    type: 'stakeholder_media',
    items: null,
  },
  {
    label: 'Regulators',
    value: 'regulators',
    type: 'stakeholder_regulators',
    items: null,
    disabled: true,
  },
  {
    label: 'NGO',
    value: 'ngos',
    type: 'stakeholder_ngos',
    items: null,
  },
  {
    label: 'Nature',
    value: 'nature',
    type: 'stakeholder_nature',
    items: null,
    disabled: true,
  },
  {
    label: 'Future Generations',
    value: 'future_generations',
    type: 'stakeholder_future_generations',
    items: null,
    disabled: true,
  },
  {
    label: 'Others',
    value: 'others',
    type: 'stakeholder_others',
    items: null,
    disabled: true,
  },
];

export const DEFAULT_STEP = 'initiate';
export const DEFAULT_COUNTER_COMPETITORS = 10;

export const FIELD_KEYS = {
  ROLE: 'role',
  VALUE_CHAIN: 'valueChain',
  FULL_NAME: 'fullName',
  INDUSTRY: 'industry',
  STATE: 'state',
  COUNTRY: 'country',
  COUNTRY_CODE: 'countryCode',
  CATEGORY: 'category',
  CATEGORY_NAME: 'categoryName',
  CATEGORY_NAMES: 'categoryNames',
  SOURCE: 'source',
  SPECIFIC_SENSITIVITY: 'specificSensitivity',
  SENSITIVITY_NAME: 'sensitivityName',
  SENSITIVITY_NAMES: 'sensitivityNames',
  ACTIONS: 'actions',
  INDUSTRY_CODE: 'industryCode',
  SECTOR_CODE: 'sectorCode',
  ACTION: 'action',
  REGIONS: 'regions',
} as const;

export const SURVEY_STATUS = {
  DRAFT: 'draft',
  DONE: 'done',
} as const;

export const SURVEY_QUESTION_TYPES = {
  SHORT_ANSWER: 'short-answer',
  PARAGRAPH: 'paragraph',
  SINGLE_SELECT: 'single-select',
  MULTIPLE_SELECT: 'multiple-select',
  PRIORITIZE: 'prioritize',
} as const;

export const MA_SURVEY_TABLE_TABS = {
  SURVEY: [
    { id: 1, name: 'surveyTemplates' },
    { id: 2, name: 'surveys' },
  ],
  INTERVIEW: [
    { id: 1, name: 'surveyTemplates' },
    { id: 2, name: 'interviews' },
  ],
  ROUNDTABLE: [
    { id: 1, name: 'surveyTemplates' },
    { id: 2, name: 'roundTables' },
  ],
};

export const MA_INSIGHT_TYPES = {
  SURVEY: 'survey',
  INTERVIEW: 'interview',
  ROUNDTABLE: 'roundtable',
};

export interface IMaterialAssessmentPageConfigs {
  SURVEY: {
    type: 'SURVEY',
    titleKey: string,
    insightType: string,
    tabsConfigKey: 'SURVEY',
    headerTranslationKey: string,
    emptyTableTranslationKey: string,
  },
  INTERVIEW: {
    type: 'INTERVIEW',
    titleKey: string,
    insightType: string,
    tabsConfigKey: 'INTERVIEW',
    headerTranslationKey: string,
    emptyTableTranslationKey: string,
  },
  ROUNDTABLE: {
    type: 'ROUNDTABLE',
    titleKey: string,
    insightType: string,
    tabsConfigKey: 'ROUNDTABLE',
    headerTranslationKey: string,
    emptyTableTranslationKey: string,
  },
}

export const MATERIAL_ASSESSMENT_PAGE_CONFIGS: IMaterialAssessmentPageConfigs = {
  SURVEY: {
    type: 'SURVEY',
    titleKey: 'materialityAssessment.surveys',
    insightType: MA_INSIGHT_TYPES.SURVEY,
    tabsConfigKey: 'SURVEY',
    headerTranslationKey: 'materialityAssessment.titleSurvey',
    emptyTableTranslationKey: 'materialityAssessment.emptySentSurveysTable',
  },
  INTERVIEW: {
    type: 'INTERVIEW',
    titleKey: 'materialityAssessment.interview',
    insightType: MA_INSIGHT_TYPES.INTERVIEW,
    tabsConfigKey: 'INTERVIEW',
    headerTranslationKey: 'materialityAssessment.titleSurvey',
    emptyTableTranslationKey: 'materialityAssessment.emptySentInterviewsTable',
  },
  ROUNDTABLE: {
    type: 'ROUNDTABLE',
    titleKey: 'materialityAssessment.roundtables',
    insightType: MA_INSIGHT_TYPES.ROUNDTABLE,
    tabsConfigKey: 'ROUNDTABLE',
    headerTranslationKey: 'materialityAssessment.titleSurvey',
    emptyTableTranslationKey: 'materialityAssessment.emptySentRoundtablesTable',
  },
};

export const MATERIAL_ASSESSMENT_RESPONDENT = {
  suppliers: 'Suppliers',
  investors: 'Investors',
  boards: 'Boards',
  employees: 'Employees',
  customers: 'Customers',
  local_communities: 'Local Communities',
  media: 'Media',
  regulators: 'Regulators',
  ngos: 'NGOs',
  nature: 'Nature',
  future_generations: 'Future Generations',
  others: 'Others',
};

export const KEYS_FIELDS_SUPPLIER_VC = {
  VALUE_CHAIN_NAME: 'valueChainName',
  STATUS: 'status',
  CREATED: 'created',
  LAST_MODIFIED: 'lastModified',
};

export const KEYS_FIELDS_SUPPLIER_MINI = {
  CHECKBOX: 'checkbox',
  SUPPLIER_NAME: 'supplierName',
  SUPPLIER_SYSTEM_UNIQUE_IDENTIFIER: 'supplierSystemUniqueIdentifier',
  SUPPLIER_CODE: 'supplierCode',
  VALUE_CHAIN_POSITION: 'valueChainPosition',
  UPSTREAM_TIER: 'upstreamTier',
  OWNERSHIP: 'ownership',
};

export const KEYS_FIELDS_CUSTOMER_MINI = {
  CHECKBOX: 'checkbox',
  CUSTOMER_NAME: 'customerName',
  CUSTOMER_SYSTEM_UNIQUE_IDENTIFIER: 'customerSystemUniqueIdentifier',
  CUSTOMER_CODE: 'customerCode',
  VALUE_CHAIN_POSITION: 'valueChainPosition',
  UPSTREAM_TIER: 'upstreamTier',
  OWNERSHIP: 'ownership',
};

export const KEYS_FIELDS_QUESTION = {
  QUESTION_NAME: 'question',
  QUESTION: 'questionType',
  SOURCE: 'questionSourceType',
  COMPANY_NAME: 'companyName',
  EVIDENCE_SOURCE: 'source',
  QUESTION_GROUP: 'questionGroup',
  DISCLOSURE: 'disclosure',
  CATEGORY: 'category',
  REQUIRED_BY: 'requiredBy',
  COUNTRY: 'country',
  SOURCEDisc: 'source',
  VALUE_CHAIN: 'valueChainName',
};

export const STATUS_SECTIONS = {
  EMPTY: 'empty',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  INTERNAL_PROCESSING: 'internal_processing',
} as const;

export const SECTION_TYPE = {
  STAKEHOLDER_IDENTIFICATION: 'stakeholder_identification',
  STAKEHOLDER_IDENTIFICATION_VCM: 'stakeholder_identification_vcm',
  STAKEHOLDER_SUPPLIERS: 'stakeholder_suppliers',
  STAKEHOLDER_CUSTOMERS: 'stakeholder_customers',
  STAKEHOLDER_INVESTORS: 'stakeholder_investors',
  STAKEHOLDER_BOARDS: 'stakeholder_boards',
  STAKEHOLDER_EMPLOYEES: 'stakeholder_employees',
  STAKEHOLDER_LOCAL_COMMUNITIES: 'stakeholder_local_communities',
  STAKEHOLDER_MEDIA: 'stakeholder_media',
  STAKEHOLDER_REGULATORS: 'stakeholder_regulators',
  STAKEHOLDER_NGOS: 'stakeholder_ngos',
  STAKEHOLDER_NATURE: 'stakeholder_nature',
  STAKEHOLDER_FUTURE_GENERATIONS: 'stakeholder_future_generations',
  STAKEHOLDER_OTHERS: 'stakeholder_others',
  TOPIC_IDENTIFICATION_1: 'topic_identification_1',
  TOPIC_IDENTIFICATION_1_VCM: 'topic_identification_1_vcm',
  TOPIC_1_REQUESTS: 'topic_1_requests',
  TOPIC_1_DISCLOSURES: 'topic_1_disclosures',
  TOPIC_1_PEER_COMPETITOR_INSIGHTS: 'topic_1_peer_competitor_insights',
  TOPIC_1_STAKEHOLDER_INSIGHTS: 'topic_1_stakeholder_insights',
  TOPIC_1_GEOGRAPHIC_RISKS: 'topic_1_geographic_risks',
  TOPIC_1_NACE_SECTION_RISKS: 'topic_1_nace_section_risks',
  TOPIC_REFINEMENT_1: 'topic_refinement_1',
  INSIGHT_CREATION: 'insight_creation',
  INSIGHT_SURVEY: 'insight_survey',
  INSIGHT_SURVEY_VCM: 'insight_survey_vcm',
  INSIGHT_INTERVIEWS: 'insight_interviews',
  INSIGHT_INTERVIEWS_VCM: 'insight_interviews_vcm',
  INSIGHT_ROUNDTABLES: 'insight_roundtables',
  INSIGHT_ROUNDTABLES_VCM: 'insight_roundtables_vcm',
  INSIGHT_DASHBOARD: 'insight_dashboard',
  TOPIC_REFINEMENT_2: 'topic_refinement_2',
  IRO_IDENTIFICATION: 'iro_identification',
  IRO_IDENTIFICATION_VCM: 'iro_identification_vcm',
  IRO_REFINEMENT: 'iro_refinement',
  IRO_SCORING: 'iro_scoring',
} as const;

export const CONST_DISABLED_STAKEHOLDERS = ['regulators', 'nature', 'future_generations', 'others'];

export const OPTIONS_PEER_COMPETITOR = [
  {
    value: 'peer',
    label: 'Peer',
  },
  {
    value: 'competitor',
    label: 'Competitor',
  },
];

export const DEFAULT_VC_ITEM = { id: undefined, firstName: undefined, lastName: undefined };

export const INSIGHT_TYPES = {
  SURVEY: 'survey',
  INTERVIEW: 'interview',
  ROUNDTABLE: 'roundtable',
  AI: 'ai',
  GLOBAL: 'global',
};

export const OPTIONS_STAKEHOLDER_TYPE = [
  {
    value: 'customer',
    label: 'Customer',
  },
  {
    value: 'investor',
    label: 'Investor',
  },
  {
    value: 'supplier',
    label: 'Supplier',
  },
];

export const COEFFICIENTS_SLIDER = {
  MIN: -10,
  MAX: 10,
  STEP: 1,
};

export const IRO_QUESTIONS = {
  IMPACT: 'impact',
  OPPORTUNITIES: 'opportunities',
  RISKS: 'risks',
};

export const IRO_QUESTION_TYPES = {
  SELECT: 'select',
  RATE: 'rate',
  SWITCH: 'switch',
};

export const SURVEY_ANSWER_TYPES = {
  IRO: 'Iro',
  INSIGHT: 'Insight',
};

export const INSIGHT_ITEMS = ['insight_survey', 'insight_interviews',
  'insight_roundtables'];

export const INSIGHT_ITEMS_TYPES = {
  INSIGHTS: 'insights',
  INITIATE: 'initiate',
};
